import { api } from "../api";
import type { NotificationListResponse, PushSubscriptionPayload } from "./notification.types";

export const notificationsApi = {
    getNotifications: async (
        params?: { limit?: number; offset?: number },
    ): Promise<NotificationListResponse> => {
        const { data } = await api.get("/notifications", { params });
        return data;
    },

    markRead: async (eventId: string): Promise<{ ok: boolean }> => {
        const { data } = await api.patch(
            `/notifications/${eventId}/read`,
        );
        return data;
    },

    markAllRead: async (): Promise<{ ok: boolean; count: number }> => {
        const { data } = await api.post("/notifications/read-all");
        return data;
    },

    registerPushToken: async (
        payload: PushSubscriptionPayload,
    ): Promise<{ ok: boolean }> => {
        const { data } = await api.post(
            "/notifications/push-token",
            payload,
        );
        return data;
    },

    deletePushToken: async (token: string): Promise<{ ok: boolean }> => {
        const { data } = await api.delete("/notifications/push-token", {
            data: { token },
        });
        return data;
    },
};
